import {VoteResource} from '@services/resource/vote-resource';
import {UUID} from '@util/types';
import moment from 'moment';

export class Vote {
  constructor(
    public readonly productUuid: UUID,
    public readonly cycleUuid: UUID,
    public readonly companyUuid: UUID,
    public readonly verdict: number,
    public readonly created: moment.Moment,
  ) {}

  public static fromResource(r: VoteResource): Vote {
    return new Vote(r.productUuid, r.cycleUuid, r.companyUuid, r.verdict, moment(new Date(r.created)));
  }
}
